import { render } from "./BillingFail.vue?vue&type=template&id=90063732&scoped=true"
import script from "./BillingFail.vue?vue&type=script&lang=js"
export * from "./BillingFail.vue?vue&type=script&lang=js"

import "./BillingFail.vue?vue&type=style&index=0&id=90063732&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90063732"]])

export default __exports__